import { useState } from 'react'

import type { UseToggleReturn } from './types'

export const useToggle = (initialValue = false): UseToggleReturn => {
  const [value, setValue] = useState<boolean>(initialValue)

  const setUntoggled = (): void => setValue(false)

  const setToggled = (): void => setValue(true)

  const toggle = (): void => setValue(prevValue => !prevValue)

  return { value, setValue, setUntoggled, setToggled, toggle }
}
